// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingInvoiceListResponse

import { hydrateBillingInvoice, type BillingInvoice, type BillingInvoiceApiResponse } from './billingInvoice.gen';

export type BillingInvoiceListApiResponse = {
	items: BillingInvoiceApiResponse[];
};

export type BillingInvoiceList = {
	items: BillingInvoice[];
};

export function hydrateBillingInvoiceList(data: BillingInvoiceListApiResponse): BillingInvoiceList {
	return {
		...data,
		items: data.items.map(hydrateBillingInvoice),
	};
}